import '../../../styles/raid-control-mobile-orientation-guard.css';

const LANDSCAPE_BLOCKED_CLASS = 'raid-control-chat-landscape-blocked';
const LANDSCAPE_QUERY = '(orientation: landscape)';
const STANDALONE_QUERY = '(display-mode: standalone)';
const MOBILE_BREAKPOINT = 760;

function readRoute() {
  return window.location.hash.replace(/^#\/?/, '').split('?')[0].replace(/\/+$/, '');
}

function isStandaloneDisplay() {
  return window.matchMedia?.(STANDALONE_QUERY).matches || window.navigator.standalone === true;
}

function isPhoneSizedDevice() {
  const screenWidth = Number(window.screen?.width || 0);
  const screenHeight = Number(window.screen?.height || 0);
  const shortestSide = Math.min(
    screenWidth || Number.POSITIVE_INFINITY,
    screenHeight || Number.POSITIVE_INFINITY,
  );
  return shortestSide <= MOBILE_BREAKPOINT;
}

function ensureGuard() {
  let guard = document.querySelector('.raid-control-chat-orientation-guard');
  if (guard) return guard;

  guard = document.createElement('section');
  guard.className = 'raid-control-chat-orientation-guard';
  guard.setAttribute('role', 'dialog');
  guard.setAttribute('aria-modal', 'true');
  guard.setAttribute('aria-hidden', 'true');
  guard.innerHTML = '<div><strong>세로 화면으로 돌려주세요</strong><span>유니온 채팅은 세로 모드에서만 사용할 수 있습니다.</span></div>';
  document.body.append(guard);
  return guard;
}

export function createMobileChatOrientationGuard({ hasChatWorkspace }) {
  const landscapeMedia = window.matchMedia?.(LANDSCAPE_QUERY) || null;
  const guard = ensureGuard();
  let orientationLockRequested = false;

  const requestPortraitLock = async () => {
    if (readRoute() !== 'control' || !isStandaloneDisplay() || orientationLockRequested) return;
    const orientation = window.screen?.orientation;
    if (typeof orientation?.lock !== 'function') return;

    orientationLockRequested = true;
    try {
      await orientation.lock('portrait-primary');
    } catch {
      // iOS may reject Screen Orientation locking in a standalone PWA.
    } finally {
      orientationLockRequested = false;
    }
  };

  const releasePortraitLock = () => {
    orientationLockRequested = false;
    const orientation = window.screen?.orientation;
    if (typeof orientation?.unlock !== 'function') return;
    try {
      orientation.unlock();
    } catch {
      // Ignore browsers that expose unlock but reject it in the current context.
    }
  };

  const sync = () => {
    const controlRoute = readRoute() === 'control';
    const mobileContext = Boolean(hasChatWorkspace()) || isPhoneSizedDevice();
    const landscape = Boolean(
      landscapeMedia?.matches
      || window.innerWidth > window.innerHeight,
    );
    const blocked = controlRoute && mobileContext && landscape;

    document.documentElement.classList.toggle(LANDSCAPE_BLOCKED_CLASS, blocked);
    guard.setAttribute('aria-hidden', blocked ? 'false' : 'true');

    if (controlRoute) void requestPortraitLock();
    else releasePortraitLock();
    return { blocked };
  };

  const handleMediaChange = () => sync();
  landscapeMedia?.addEventListener?.('change', handleMediaChange);

  return {
    sync,
    destroy() {
      landscapeMedia?.removeEventListener?.('change', handleMediaChange);
      document.documentElement.classList.remove(LANDSCAPE_BLOCKED_CLASS);
      guard.remove();
      releasePortraitLock();
    },
  };
}
